import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/crop_actions";
import cellGenerator from "./columnUtils";

const crop_columns = (isSubaccount) => [
  {
    Header: "Profile Name",
    accessor: "CropFormData.new_profile_crop_profile_name",
    Cell: (props) => cellGenerator(props),
    id: "profile-name",
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Crop ID",
    accessor: "CropFormData.new_profile_crop_crop_id",
    Cell: (props) => cellGenerator(props),
    fixedWidth: 120,
  },
  {
    Header: "Work State",
    accessor: "CropFormData.new_profile_crop_crop_work_state",
    Cell: (props) => cellGenerator(props),
    fixedWidth: 120,
  },
  {
    Header: "Crop or Agricultural Activity",
    accessor: "CropFormData.new_profile_crop_crop_agricultural_activity",
    Cell: (props) => cellGenerator(props),
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("crop", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default crop_columns;
